import './sentry'; // must be first — initialises Sentry before any other module
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AppErrorBoundary } from './ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
const publicSiteRoutes = ['/pricing', '/contact', '/privacy', '/terms'];

// Shopify sends merchants here with ?shop=...&hmac=...&host=... after install.
// Detect these params so we route to App (which handles OAuth) instead of the
// marketing landing page.
const _qs = new URLSearchParams(window.location.search);
const _isShopifyLaunch = _qs.has('shop') || (_qs.has('hmac') && _qs.has('host'));

if (window.location.pathname === '/features') {
  // Preserve the legacy public route while keeping the redesigned product
  // section canonical. This must stay outside the application router so a
  // marketing visitor is never sent to the authenticated login surface.
  window.location.replace('/#product');
} else if (!_isShopifyLaunch && (window.location.pathname === '/' || window.location.pathname === '/landing-demo')) {
  // The product application uses a full-height shell with its own scroll area.
  // The landing page must instead use the browser's document scroller so touch
  // scrolling behaves normally in mobile Safari and Chrome.
  document.documentElement.classList.add('landing-demo-page');
  document.body.classList.add('landing-demo-page');

  import('./LandingPageDemo').then(({ default: LandingPageDemo }) => {
    root.render(
      <AppErrorBoundary>
        <LandingPageDemo />
      </AppErrorBoundary>
    );
  });
} else if (publicSiteRoutes.includes(window.location.pathname)) {
  import('./PublicSiteRouter').then(({ default: PublicSiteRouter }) => {
    root.render(
      <AppErrorBoundary>
        <PublicSiteRouter />
      </AppErrorBoundary>
    );
  });
} else {
  import('./App').then(({ default: App }) => {
    root.render(
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    );
  });
}
